'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPriceBySymbol = exports.formatPrice = undefined;

var _currencies = require('./currencies.json');

var _currencies2 = _interopRequireDefault(_currencies);

var _constants = require('./constants');

var _index = require('./index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SPACE = ' ';

var baseFormatter = function baseFormatter(left, right) {
  var spacing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return '' + left + spacing + right;
};

var defaultFormatter = {
  format: function format(value) {
    return value;
  }
};

var formatters = [{
  symbolOnLeft: true,
  spacing: true,
  format: function format(value, currency) {
    return baseFormatter(currency, value, SPACE);
  }
}, {
  symbolOnLeft: true,
  spacing: false,
  format: function format(value, currency) {
    return baseFormatter(currency, value);
  }
}, {
  symbolOnLeft: false,
  spacing: true,
  format: function format(value, currency) {
    return baseFormatter(value, currency, SPACE);
  }
}, {
  symbolOnLeft: false,
  spacing: false,
  format: function format(value, currency) {
    return baseFormatter(value, currency);
  }
}];

var formatPrice = exports.formatPrice = function formatPrice(value) {
  var isoCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DEFAULT_CURRENCY;

  var currency = _currencies2.default[isoCode] || {};

  var formatter = formatters.find(function (f) {
    return f.symbolOnLeft === currency.symbolOnLeft && f.spacing === currency.spacing;
  }) || defaultFormatter;

  return formatter.format(value, currency.symbol);
};

var formatPriceBySymbol = exports.formatPriceBySymbol = function formatPriceBySymbol(value) {
  var currencySymbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DEFAULT_CURRENCY_SYMBOL;

  var isoCode = (0, _index.getISOCodeForCurrencySymbol)(currencySymbol);
  return formatPrice(value, isoCode);
};

exports.default = {
  formatPrice: formatPrice,
  formatPriceBySymbol: formatPriceBySymbol
};
//# sourceMappingURL=formatter.js.map